var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-no-message-box"},[_c('div',{staticClass:"tc-100"}),_c('div',{staticClass:"my-no-message-inner-img-box"},[_c('img',{attrs:{"src":require("../../../assets/img/noMessage/no-message0.png"),"alt":""}})]),_c('div',{staticClass:"my-no-message-inner-font"},[_vm._v("购物车为空哦")])])
}]

export { render, staticRenderFns }